import { render, staticRenderFns } from "./AliPayHK.vue?vue&type=template&id=173de973&"
import script from "./AliPayHK.vue?vue&type=script&lang=js&"
export * from "./AliPayHK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports